export const COMPENSATION_REVIEW_THRESHOLD = 100;

/**
 * Calculates percentage increase from current CTC to expected CTC.
 * Formula: ((Expected CTC - Current CTC) / Current CTC) * 100
 * @param {number|string} currentCtc 
 * @param {number|string} expectedCtc 
 * @returns {number} Calculated percentage increase
 */
export const calculateCtcIncreasePercentage = (currentCtc, expectedCtc) => {
  if (!currentCtc || !expectedCtc) return 0;
  
  // Clean inputs (removing non-numeric except decimal point)
  const cleanCurrentStr = String(currentCtc).replace(/[^0-9.]/g, '');
  const cleanExpectedStr = String(expectedCtc).replace(/[^0-9.]/g, '');
  
  const current = parseFloat(cleanCurrentStr);
  const expected = parseFloat(cleanExpectedStr);
  
  if (isNaN(current) || isNaN(expected) || current <= 0) {
    return 0;
  }
  
  const increase = ((expected - current) / current) * 100;
  return Math.max(0, increase);
};

/**
 * Determines compensation review scenario based on increase percentage.
 * @param {number} percentage 
 * @returns {'NONE'|'ENHANCED'}
 */
export const getCompensationReviewScenario = (percentage) => {
  if (percentage > COMPENSATION_REVIEW_THRESHOLD) {
    return 'ENHANCED';
  }
  return 'NONE';
};

